module.exports = __webpack_public_path__ + "media/images/features/draft/icon-flow-02-de2f64298358dcf91f6183b6134e5f72.svg";